<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Dar de alta nuevo empleado
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="employeeForm">
        <div class="form-group">
            <label for="employeeFormName" class="form-label">Nombre(s)</label>
            <input type="text" class="form-control" id="employeeFormName" formControlName="name">
        </div>
        <p *ngIf="employeeForm.controls['name'].touched && employeeForm.controls['name'].invalid" class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormLastName" class="form-label">Apellidos</label>
            <input type="text" class="form-control" id="employeeFormLastName" formControlName="lastName">
        </div>
        <p *ngIf="employeeForm.controls['lastName'].touched && employeeForm.controls['lastName'].invalid"
            class="text-danger">Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormEmail" class="form-label">Email</label>
            <input type="text" class="form-control" id="employeeFormEmail" formControlName="email">
        </div>
        <p *ngIf="employeeForm.controls['email'].touched && employeeForm.controls['email'].invalid && !employeeForm.controls['email'].errors!['pattern']"
            class="text-danger">Este campo es requerido</p>
        <p *ngIf="employeeForm.controls['email'].touched && employeeForm.controls['email'].invalid && employeeForm.controls['email'].errors!['pattern']"
            class="text-danger">Enter a valid email address</p>
        <div class="form-group">
            <label for="employeeFormPassword" class="form-label">Contraseña</label>
            <input type="text" class="form-control" id="employeeFormPassword" formControlName="password">
        </div>
        <p *ngIf="employeeForm.controls['password'].touched && employeeForm.controls['password'].invalid"
            class="text-danger">Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormPhone" class="form-label">Teléfono</label>
            <input type="number" class="form-control" id="employeeFormPhone" formControlName="phone">
        </div>
        <p *ngIf="employeeForm.controls['phone'].touched && employeeForm.controls['phone'].invalid"
            class="text-danger">Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormDate" class="form-label">Fecha de entrada</label>
            <input type="date" class="form-control" id="employeeFormDate" formControlName="entranceDate">
        </div>
        <p *ngIf="employeeForm.controls['entranceDate'].touched && employeeForm.controls['entranceDate'].invalid"
            class="text-danger">Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormRole" class="form-label">Rol</label>
            <select class="form-control" id="employeeFormRole" formControlName="role">
                <option value="" disabled>
                    <span>Rol</span>
                </option>
                <option value="admin">
                    <span>Administrador</span>
                </option>
                <option value="supervisor">
                    <span>Supervisor</span>
                </option>
                <option value="auditor">
                    <span>Auditor</span>
                </option>
                <option value="employee">
                    <span>Empleado</span>
                </option>
            </select>
        </div>
        <p *ngIf="employeeForm.controls['role'].touched && employeeForm.controls['role'].invalid" class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="employeeFormDescription" class="form-label">Descripción</label>
            <textarea type="text" class="form-control" id="employeeFormDescription" formControlName="description"
                rows="3"></textarea>
        </div>
        <p *ngIf="employeeForm.controls['description'].touched && employeeForm.controls['description'].invalid"
            class="text-danger">Este campo es requerido</p>
    </form>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="employeeForm.invalid || isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>